import { InfoIcon, Tooltip } from '@lokalise/louis'

import styles from './CardTitle.module.css'

type CardTitleProps = {
  title: string
  tooltip?: string
}

export const CardTitle = ({ title, tooltip }: CardTitleProps) => (
  <div className="flex items-center gap-2">
    <span className={styles.title}>{title}</span>
    {!!tooltip && (
      <Tooltip classNames={{ content: styles.tooltip }} placement="bottom" tooltip={tooltip}>
        <span data-testid="More information" className="flex">
          <InfoIcon size="16px" />
        </span>
      </Tooltip>
    )}
  </div>
)
